import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const MainViewOne = ({ mainViewRef, mainTitlemainViewRef, overlayTitlemainViewRef }) => {
    const { t } = useTranslation()

    return (
        <div className='sub-main' ref={mainViewRef} id='view-1'>
            <div className='container'>
                <div className='animate custom'></div>
                <div className='title'>
                    <div className='main-title'>
                        <h3>
                            {t("EXPERT_WITH_YOU")}

                            <div className='overlay' ref={mainTitlemainViewRef}>
                                <h3 ref={overlayTitlemainViewRef}>{t("EXPERT_WITH_YOU")}</h3>
                            </div>
                        </h3>
                    </div>

                    <Link to='/team' className='cto-button-container'>
                        <div className='btn'>{t("MEET_EXPERTS")}</div>
                    </Link>
                </div>
            </div>
        </div>
    );
}

export default MainViewOne;